'use client';

import { SomethingWentWrong } from '../components/common/error/something-went-wrong';

export default function ErrorPage({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <SomethingWentWrong error={error} />;
}
